<template>
    <div id="showbackups">
		<loading :active.sync="fullPageWait"
                 :can-cancel="false"
                 :is-full-page="true"/>
        <b-modal id="bcktext" title="File comment">
            <pre>{{filecomment}}</pre>
        </b-modal>
        <b-container fluid>
            <h1>
                <span>Backups</span>
            </h1>
            <b-row>
                <b-col>
                    <b-card class="l10">
                        <b-container fluid>
                            <b-row>
                                <b-col></b-col>
                                <b-col cols="6">
                                    <DxTreeList
                                        id="backups"
                                        :data-source="dataSource"
                                        :show-borders="true"
                                        :column-auto-width="true"
                                        :word-wrap-enabled="true"
                                        key-expr="id_file"
                                        parent-id-expr="id_parent"
                                        @rowClick="onRowClick"
                                    >
                                        <DxSearchPanel
                                            :visible="true"
                                            :width="250"
                                        />
                                        <DxHeaderFilter :visible="false" />
                                        <DxColumnChooser :enabled="false" />

                                        <DxColumn
                                            :width="500"
                                            data-field="path"
                                        />
                                        <DxColumn
                                            :width="150"
                                            caption=""
                                            data-field="c"
                                            cell-template="radioTemplateC"
                                        />
                                        <template #radioTemplateC="{ data: d }">
                                            <b-button
                                                @click="
                                                    download(d.data.id_file)
                                                "
                                                v-if="!d.data.isdir"
                                                :disabled="!enabled"
                                                ><v-icon name="download" />
                                                Download</b-button
                                            >
                                        </template>
                                    </DxTreeList>
                                </b-col>
                                <b-col cols="4">
                                    <b-card v-if="!$store.getters.ro" title="Upload Backup (max 250MB) *">
                                        <img
                                            src="/images/backup.jpg"
                                            width="200"
                                        />
                                        <b-form
                                            @submit.prevent="onSubmit()"
                                            @reset="onReset"
                                        >
                                            <b-row>
                                                <b-col>
                                                    <b-form-file
                                                        v-model="file"
                                                        :state="Boolean(file)"
                                                        placeholder="Choose a file or drop it..."
                                                        drop-placeholder="Drop file here..."
                                                    ></b-form-file>
                                                    <b-form-textarea
                                                        id="textarea"
                                                        v-model="filetext"
                                                        placeholder="Enter a comment ..."
                                                        rows="3"
                                                        max-rows="6"
                                                    ></b-form-textarea>
                                                    <b-button
                                                        @click="file = null"
                                                        v-if="Boolean(file)"
                                                        >Reset</b-button
                                                    >
                                                </b-col>
                                            </b-row>
                                            <b-button
                                                type="submit"
                                                variant="primary"
                                                >Submit</b-button
                                            >
                                            <br><br><br>
                                            <p class="smallfont">
                                                * For security reasons, the system provides only the possibility of uploading your backups but not editing or deleting them
                                            </p>
                                            <b-alert
                                                :show="dismissCountDownNO"
                                                dismissible
                                                variant="danger"
                                                @dismissed="dismissCountDownNO = 0"
                                                @dismiss-count-down="countDownChangedNO"
                                            >
                                                Backup Too BIG !!
                                            </b-alert>
                                            <b-alert
                                                :show="dismissCountDown"
                                                dismissible
                                                variant="info"
                                                @dismissed="dismissCountDown = 0"
                                                @dismiss-count-down="countDownChanged"
                                            >
                                                Backup uploaded!
                                            </b-alert>
                                            <b-alert
                                                :show="dismissCountDownERR"
                                                dismissible
                                                variant="danger"
                                                @dismissed="dismissCountDownERR = 0"
                                                @dismiss-count-down="countDownChangedERR"
                                            >
                                                Backup uploaded!
                                            </b-alert>
                                        </b-form>
                                    </b-card>
                                </b-col>
                                <b-col></b-col>
                            </b-row>
                        </b-container>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import {
    DxTreeList,
    DxColumn,
    DxColumnChooser,
    DxHeaderFilter,
    DxSearchPanel,
    // DxSelection,
} from "devextreme-vue/tree-list";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { API } from "@/api.js";

const development = process.env.NODE_ENV === "development";
const SERVER = development
    ? "http://localhost:81"
    : location.protocol +
      "//" +
      location.hostname +
      (location.port ? ":" + location.port : "");

export default {
    components: {
        DxTreeList,
        DxColumn,
        DxColumnChooser,
        DxHeaderFilter,
        DxSearchPanel,
		Loading,
    },
    props: {
        m: Object,
    },
    data() {
        return {
            components: [],
            docUrl: false,
            enabled: true,
            file: null,
            filetext: "",
            dismissCountDown: 0,
            dismissCountDownNO: 0,
            dismissCountDownERR: 0,
            dismissSecs: 5,
            dismissSecsNO: 5,
            dismissSecsERR: 5,
			filecomment: '',
			fullPageWait: false,
        };
    },
    mounted() {
        this.init();
    },
    computed: {
        SERVER() {
            return SERVER;
        },
        dataSource() {
            return this.components;
        },
    },
    methods: {
        async onRowClick(e) {
            console.log("E", e);
            if (e.event.target.tagName.toLowerCase() !== "span") {
				let txt = await API.getBackupComment(e.data.id_file)
				if(txt) {
					this.filecomment = txt
					this.$bvModal.show("bcktext")
				} else {
					this.filecomment = "No info available"
					this.$bvModal.show("bcktext")
				}
            }
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        countDownChangedNO(dismissCountDownNO) {
            this.dismissCountDownNO = dismissCountDownNO;
        },
        countDownChangedERR(dismissCountDownERR) {
            this.dismissCountDownERR = dismissCountDownERR;
        },
        showAlert() {
            this.dismissCountDown = this.dismissSecs;
        },
        showAlertNO() {
            this.dismissCountDownNO = this.dismissSecsNO;
        },
        showAlertERR() {
            this.dismissCountDownERR = this.dismissSecsERR;
        },
        async onSubmit() {
			this.fullPageWait = true
            console.log("onSubmit", this.file,this.file.size);
            if(this.file.size > 250000000) {
                this.showAlertNO();
                // this.init();
                this.file = null
                this.filetext = ''
                this.fullPageWait = false
                return
            }
            const formData = new FormData();
            formData.append("backup", this.file);
            formData.append("mcode", this.m.codice);
            formData.append("text", this.filetext);
            let ret = await API.uploadBackup(formData);
            if(ret===false)
                this.showAlertERR();
            else
                this.showAlert();
            this.init();
			this.file = null
			this.filetext = ''
			this.fullPageWait = false
        },
        onReset() {
            console.log("onReset");
        },
        async download(doc) {
            const a = document.createElement("a");
            const link = API.getBckCall(this.m.codice, doc);
            console.log("download", doc.split("/").pop());
            a.href = link;
            a.download = doc.split("/").pop();
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
            //   document.body.removeChild(a);
        },
        async init() {
            // console.log("M", this.m);
            let res = await API.getBackups(this.m.codice);
            // sistemo i nomi delle cartelle padre
            res.map((b) => {
                if (b.id_parent) return b;
                if (b.id_file.startsWith("Backups/"))
                    b.path = "Marsilli Backup";
                else if (b.id_file.startsWith("Backups2/"))
                    b.path = "Marsilli Storage";
                else if (b.id_file.startsWith("Backups3/"))
                    b.path = "Custom Backup";
                return b;
            });
            this.components = res;
            // console.log("backups", this.components);
        },
    },
};
</script>
<style>
#showcomps img.pointer {
    cursor: pointer;
}
#backups {
    max-height: calc(100vh - 290px);
    height: calc(100vh - 290px);
}

#backups .dx-treelist-rowsview td {
    vertical-align: middle;
}
#showbackups button path {
    fill: white;
}
#showbackups div.dx-treelist-text-content {
    cursor: pointer;
}
</style>
<style scoped>
p.smallfont {
    font-size: x-small;
}
h1 span.r {
    float: right;
    fill: white;
}
td {
    padding: 5px;
}
div.docview {
    max-height: calc(100vh - 248px);
    height: calc(100vh - 248px);
    overflow: auto;
    right: 10px;
}
span.dl {
    float: right;
    margin-right: 80px;
    cursor: pointer;
}
div.l10 {
    left: 10px;
}
</style>
